import Skeleton from "@mui/material/Skeleton";
import style from "./style.module.scss";

export const LoadingProduct = () => {
  return (
    <div className={style.loadingProduct}>
      <Skeleton variant="rectangular" width={180} height={200} />
      <Skeleton width="80%" />
      <Skeleton width="60%" />
      <Skeleton variant="rectangular" width={180} height={40} />
    </div>
  );
};

export default LoadingProduct;
